import { useEffect, useState } from 'react';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { UserProfile } from '../../../../corelogic/domain/models/user.model';
import { store } from '../../../../corelogic/state/store';
import {
  getCurrentUser,
  getUserLoading,
} from '../../../../corelogic/state/user/user.selector';

// User Profile Hook
const user$: Observable<UserProfile | null> = store.select(getCurrentUser);
const loading$: Observable<boolean> = store.select(getUserLoading);

export const useUserProfile = () => {
  const [user, setUser] = useState<UserProfile | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const usersub = user$.pipe(distinctUntilChanged()).subscribe(setUser);
    console.log('User Profile set:', user);
    const loadingSub = loading$
      .pipe(distinctUntilChanged())
      .subscribe(setIsLoading);

    return () => {
      usersub.unsubscribe();
      loadingSub.unsubscribe();
    };
  }, []);

  return { user, isLoading };
};
